/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heating_Curve_History_Network_DemandInputs */



/**
* | output |
* | --- |
* | "Network demand (%)" |
*
* @param {Heating_Curve_History_Network_DemandInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const heating_curve_history_network_demand = /** @type {((inputs?: Heating_Curve_History_Network_DemandInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heating_Curve_History_Network_DemandInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Network demand (%)")
	return /** @type {LocalizedString} */ ("Demande du réseau (%)")
});